<template>
    <v-app id="password-reset">
        <MainNotifications />
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-card class="elevation-12 rounded">
                            <v-img src="@/assets/img/login-header.png"></v-img>
                            <div class="mt-4 ml-4">
                                <span @click="onLoginRedirect" class="link-back-to-login"> <v-icon dense> mdi-chevron-left </v-icon> Back to Login</span>
                            </div>

                            <v-card-title class="label-setup-password-title px-6 pt-4 pb-2">Setup New Password</v-card-title>
                            <v-card-text class="px-6">
                                <v-form ref="formData" class="form-data" @submit.stop.prevent="onSubmit" autocomplete="off">
                                    <v-row class="my-0">
                                        <v-col md="12">
                                            <label class="font-weight-medium"
                                                >Enter 6-digit OTP (One-Time Pincode) sent to <span class="registered-email">{{ email }}</span></label
                                            >
                                            <v-text-field
                                                v-model="formData.otp"
                                                name="otp"
                                                id="input-otp"
                                                class="input-otp"
                                                type="text"
                                                placeholder="XXXXXX"
                                                :class="[{ 'is-invalid': errors.otp }]"
                                                :error-messages="errors.otp"
                                                hide-details="auto"
                                                @keypress="isNumber($event)"
                                                maxlength="6"
                                                solo
                                                dense
                                                required
                                            ></v-text-field>

                                            <div class="resend-code mt-3">
                                                <span>No code received? </span>

                                                <span :class="['link-resend-code', { disabled: disabledResend || sendCodeProcessing }]" @click="onResendCode"
                                                    >Resend Code
                                                    <span v-if="countDown"> in {{ countDown }} seconds</span>
                                                </span>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row class="my-0">
                                        <v-col md="12">
                                            <label for="password" class="font-weight-medium">New Password</label>
                                            <v-text-field
                                                :type="showPassword ? 'text' : 'password'"
                                                v-model="formData.password"
                                                :class="['mt-1', { 'is-invalid': errors.password }]"
                                                :error-messages="errors.password"
                                                hide-details="auto"
                                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="showPassword = !showPassword"
                                                autocomplete="nope"
                                                placeholder="Enter password"
                                                solo
                                                dense
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col md="12">
                                            <div class="password-requirement mb-6">Password must contain at least one uppercase letter, one lowercase letter, one number and one special character</div>
                                            <label for="confirm_password" class="font-weight-medium">Re-type Password</label>
                                            <v-text-field
                                                :type="showPasswordConfirmation ? 'text' : 'password'"
                                                v-model="formData.password_confirmation"
                                                :class="['mt-1', { 'is-invalid': errors.password_confirmation }]"
                                                :error-messages="errors.password_confirmation"
                                                hide-details="auto"
                                                :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                                                autocomplete="nope"
                                                placeholder="Enter password"
                                                solo
                                                dense
                                                required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-btn type="submit" block class="mt-4" :loading="formData.loading" color="primary">Reset Password</v-btn>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-dialog v-model="successDialog.show" scrollable max-width="550" color="primaryBackgroundColor" transition="scroll-y-reverse-transition" persistent>
                    <v-card class="confirm-dialog text-center pt-10 pb-5">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon class="dialog-close" v-on="on" @click="onLoginRedirect">close</v-icon>
                            </template>
                            <span>Close</span>
                        </v-tooltip>
                        <img class="icon-success" src="@/assets/img/registration-success.svg" />
                        <v-card-text>
                            <h2 class="content-title pb-5">
                                {{ successDialog.data.title }}
                            </h2>
                            <p class="content-description ma-0">
                                {{ successDialog.data.description }}
                            </p>
                            <v-btn @click="onLoginRedirect" block class="mt-8" color="primary">Login</v-btn>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import MainNotifications from '@/components/Core/MainNotifications.vue';
export default {
    components: {
        MainNotifications
    },
    data() {
        return {
            showPassword: false,
            showPasswordConfirmation: false,
            formData: {
                loading: false,
                otp: '',
                password: '',
                password_confirmation: ''
            },
            countDown: 0,
            disabledResend: false,
            sendCodeProcessing: false,
            successDialog: {
                show: false,
                data: {
                    title: '',
                    description: ''
                }
            }
        };
    },
    computed: {
        email() {
            return this.$cookies.get('emailForgotPassword') || '';
        }
    },
    mounted() {
        if (this.$cookies.get('otpStatus')) {
            this.notification({ type: 'success', title: 'Forgot Password', message: 'OTP has been successfully sent to your email.' });
            this.$cookies.remove('otpStatus');
        }

        this.countDown = this.$cookies.get('countDownPassword') ? parseInt(this.$cookies.get('countDownPassword')) : this.countDown;
    },
    watch: {
        // errors(val) {
        //     this.errors = JSON.parse(JSON.stringify(val));
        // },
        countDown: {
            handler(value) {
                if (value > 0) {
                    this.disabledResend = true;
                    setTimeout(() => {
                        this.countDown--;
                        this.$cookies.set('countDownPassword', value);
                    }, 1000);
                } else {
                    this.disabledResend = false;
                }
            },
            immediate: true // This ensures the watcher is triggered upon creation
        }
    },
    methods: {
        // handleErrors() {
        // computed property to add the confirmation error in list of errors
        // let formErrors = this.errors;
        // if (formErrors.password) {
        //     if (!this.formData.password_confirmation) {
        //         formErrors.password_confirmation = ['The new password confirmation field is required.'];
        //     }
        //     formErrors.password.forEach((error, key) => {
        //         if (error === 'New password cannot be the same as your old password') {
        //             formErrors.password_confirmation = [error];
        //         }
        //         if (error.includes('confirmation')) {
        //             formErrors.password_confirmation = [error];
        //             delete formErrors.password[key];
        //             if (formErrors.password.length === 1) {
        //                 delete formErrors.password;
        //             }
        //         }
        //     });
        // }
        // this.errors = formErrors;
        // },

        onSubmit() {
            this.formData.loading = true;
            this.formData.email = this.email;
            this.$store
                .dispatch('authentication/resetPassword', { data: this.formData })
                .then(() => {
                    this.formData.loading = false;
                    this.successDialog.data.title = 'New Password Updated!';
                    this.successDialog.data.description = `Your account’s (${this.email}) password has been successfully updated. `;
                    this.successDialog.show = true;
                })
                .catch(() => {
                    this.formData.loading = false;
                    // this.handleErrors();
                });
        },
        onLoginRedirect() {
            this.$cookies.remove('emailForgotPassword');
            this.$router.push('/login');
        },
        async onResendCode() {
            this.sendCodeProcessing = true;
            this.$store
                .dispatch('authentication/forgotPassword', { data: { email: this.email } })
                .then(() => {
                    this.disabledResend = false;
                    this.sendCodeProcessing = false;
                    this.countDown = 180; // 60
                    this.notification({ type: 'success', message: 'OTP has been successfully sent to your email.' });
                })
                .catch(() => {
                    this.disabledResend = true;
                    this.sendCodeProcessing = false;
                });
        },
        isNumber(e) {
            e = e ? e : window.event;
            const charCode = e.which ? e.which : e.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                e.preventDefault();
            } else {
                return true;
            }
        },
        getColorClass(value) {
            if (value === null) return null;
            return value.replace(/\s/g, '').length === 0 ? false : true;
        }
    },
    destroyed() {
        this.$store.commit('form/SET_ERRORS_EMPTY');
        this.$cookies.set('countDownPassword', 0);
    },
    head() {
        return {
            title: 'Reset Password'
        };
    }
};
</script>

<style lang="scss" scoped>
.confirm-dialog {
    .content-title {
        color: #16192c !important;
        font-weight: bold !important;
    }

    .content-description {
        color: #425466;
        font-size: 1.17em;
        font-weight: 500;
    }

    .dialog-close {
        color: #16192c99;
    }
}

#password-reset {
    .label-setup-password-title {
        color: #16192c;
        font-weight: bold;
    }

    .link-back-to-login {
        color: #425466;
        cursor: pointer;
        text-decoration: none;
        font-weight: 500;
        opacity: 0.6;
    }

    .link-resend-code {
        color: #4c6fff;
        cursor: pointer;
        font-weight: bold;

        &.disabled {
            color: #425466;
        }
    }

    .v-text-field {
        &.theme--light {
            .v-input__slot {
                background-color: var(--v-secondaryBackgroundColor-base);
            }
        }

        &.theme--dark {
            .v-input__slot {
                background-color: var(--v-secondaryBackgroundColor-base);
            }
        }
    }

    &::v-deep {
        .text {
            margin: 20px 0 0 0;
            text-transform: uppercase;
            font-size: 12px;

            span {
                color: #0984e3;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .password-requirement {
            color: #425466;
            font-weight: 500;
        }

        .v-card__title {
            color: #16192c;
        }
        label {
            color: #425466;
        }
        .v-input__slot {
            // background-color: #edf2f7;
            color: #16192c;

            input {
                // color: #b5b5bd;
            }
        }

        .password-white-bg {
            .v-input__slot {
                background-color: #fff;
            }
        }
    }
}

.icon-success {
    height: 80px;
    margin: 20px auto;
}

.resend-code {
    color: #425466;
    font-size: 13px;
}

a.disabled {
    pointer-events: none;
}
</style>
